import { render, staticRenderFns } from "./AccountInsuranceAuthorizationDetail.vue?vue&type=template&id=d72e7cd8&"
import script from "./AccountInsuranceAuthorizationDetail.vue?vue&type=script&lang=js&"
export * from "./AccountInsuranceAuthorizationDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports